import { css } from 'styled-components';

import {
  Headline400Skin,
  Headline500Skin,
  Headline600Skin,
  Headline700Skin,
  Headline800Skin,
} from '../components/atoms/Headline/HeadlineSkins';

/**
 * @param {string} skin
 * @returns {FlattenInterpolation<{ theme: Theme }>}
 */
const getHeadlineSkin = (skin) => {
  switch (skin) {
    case 'Headline800':
      return css`
        ${Headline800Skin}
      `;
    case 'Headline700':
      return css`
        ${Headline700Skin}
      `;
    case 'Headline600':
      return css`
        ${Headline600Skin}
      `;
    case 'Headline500':
      return css`
        ${Headline500Skin}
      `;
    case 'Headline400':
      return css`
        ${Headline400Skin}
      `;
    default:
      return css`
        ${Headline700Skin}
      `;
  }
};

export default getHeadlineSkin;
